import { Box, Text } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { mediaQueries } from 'theme/mediaQueries';

export const MobileWrapper = styled(Box)`
    display: block;

    ${mediaQueries.tabletLandscape} {
        display: none;
    }
`;

export const StepContainer = styled(Box)<{ $mb: number }>`
    ${({ $mb }) => Number.isInteger($mb) && `margin-bottom: ${$mb}px;`};
    display: flex;
    max-width: 400px;
    flex-direction: column;
    gap: 24px;
    margin: 0 auto;

    ${mediaQueries.tabletLandscape} {
        width: 100%;
        max-width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto;
        margin-bottom: 24px;
    }
`;

export const ThirdStep = styled.div<{ withoutAccessCode: boolean }>`
    grid-column: 1;
    grid-row: 1;
    ${({ withoutAccessCode }) => withoutAccessCode && 'grid-row: 1 / span 2;'};
`;

export const FourthStep = styled.div`
    grid-column: 1;
    grid-row: 2;
`;
export const FifthStep = styled.div`
    grid-column: 2;
    grid-row: 1 / span 2;
`;

export const GetAppTextMobile = styled(Text)`
    ${mediaQueries.tabletLandscape} {
        display: none;
    }
`;

export const GetAppTextDesktop = styled(Text)`
    display: none;
    white-space: break-spaces;

    ${mediaQueries.tabletLandscape} {
        display: block;
    }
`;

export const OpenAppText = styled(Text)`
    white-space: break-spaces;
`;
